import React from 'react';
import _ from 'lodash';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import {getTypeFromId} from '../../../utils/matchVehicleCategories';
import {IVehicleCategory} from '../../../interface';

interface IVehicleListProps {
  dataList: IVehicleCategory[];
  selected: number | string;
  changeVehicleTypeHandler: (value: number) => void;
  categoriesType: string;
}

const cx = classnames.bind(style);

function VehicleList(props: IVehicleListProps) {
  const {dataList, selected, changeVehicleTypeHandler, categoriesType} = props;
  return (
    <div className={cx('vehicle-list')}>
      <ul>
        {_.map(
          dataList,

          (type, index) => (
            <li
              key={index}
              className={cx({actived: _.isEqual(selected, type['id'])})}
            >
              <div
                className={cx(
                  'item',
                  _.kebabCase(getTypeFromId(type['id'], categoriesType)),
                )}
                onClick={() =>
                  type['id'] !== selected &&
                  changeVehicleTypeHandler(type['id'])
                }
              >
                <i></i>
                <span>{_.upperFirst(type['name'])}</span>
              </div>
            </li>
          ),
        )}
      </ul>
    </div>
  );
}

export default VehicleList;
